import * as yup from "yup";

export const addMobileCombustionValidation = yup.object({
  facility: yup.string().required("Facility is required"),
  month: yup.string().required("Month is required"),
  year: yup.string().required("Year is required"),
  upstreamType: yup.string().required("upstream type is required"),
});
